import { createStore } from 'vuex';

export default createStore({
    state: {
        islogin: localStorage.getItem('islogin') === 'true',        
        user: JSON.parse(localStorage.getItem('curUser')) || null,        
    },
    mutations: {
        login(state, payload) {
            state.islogin = true;
            state.user = payload.user;
            localStorage.setItem('islogin','true');            
            localStorage.setItem('curUser', JSON.stringify(payload.user));      
            localStorage.setItem('authToken', payload.token);            
        },
        logout(state) {
            state.islogin = false;
            state.user = null;
            localStorage.removeItem('islogin');            
            localStorage.removeItem('authToken');
            sessionStorage.removeItem('authToken');
            localStorage.removeItem('curUser');            
        }        
    },
    actions: {
        login({ commit }, payload) {
            commit('login', payload);                      
        },
        logout({commit}) {
            commit('logout');
        },               
    },
    getters: {
        islogin: state => state.islogin,            
        user: state => state.user,       
    }
});